import constants from '../../common/constants/CommonConstants';
import { fetchFieldMappings, updateFieldMappings } from '../routines';

const { ORGANIZATION_LEVEL, ACCOUNT_LEVEL, CONTACT_LEVEL, PIPELINE_LEVEL } =
  constants;

const initialState = {
  fieldMappingList: {
    organization: {},
    account: {},
    contact: {},
    pipeline: {},
    customObject: {},
  },
  loading: {
    organization: false,
    account: false,
    contact: false,
    pipeline: false,
    customObject: {},
  },
  errors: {
    organization: false,
    account: false,
    contact: false,
    pipeline: false,
    customObject: {},
  },
};

const fieldMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case updateFieldMappings.TRIGGER:
    case fetchFieldMappings.TRIGGER: {
      const { level } = action.payload;
      let loading;
      if (
        [
          ORGANIZATION_LEVEL,
          ACCOUNT_LEVEL,
          CONTACT_LEVEL,
          PIPELINE_LEVEL,
        ].includes(level)
      ) {
        loading = { ...state.loading, [level]: true };
      } else if (level) {
        loading = {
          ...state.loading,
          customObject: {
            ...state.loading.customObject,
            [level]: true,
          },
        };
      }
      return {
        ...state,
        loading,
      };
    }

    case fetchFieldMappings.SUCCESS: {
      const { level } = action.payload;
      const { data } = action.payload.response;
      let fieldMappingList;
      let loading;
      if (
        [
          ORGANIZATION_LEVEL,
          ACCOUNT_LEVEL,
          CONTACT_LEVEL,
          PIPELINE_LEVEL,
        ].includes(level)
      ) {
        loading = { ...state.loading, [level]: false };
        fieldMappingList = { ...state.fieldMappingList, [level]: data };
      } else if (level) {
        loading = {
          ...state.loading,
          customObject: {
            ...state.loading.customObject,
            [level]: false,
          },
        };

        fieldMappingList = {
          ...state.fieldMappingList,
          customObject: {
            ...state.fieldMappingList.customObject,
            [level]: data,
          },
        };
      }
      return {
        ...state,
        fieldMappingList,
        loading,
      };
    }

    case updateFieldMappings.FAILURE:
    case fetchFieldMappings.FAILURE: {
      const { level, error } = action.payload;
      let errors;
      let loading;
      if (
        [
          ORGANIZATION_LEVEL,
          ACCOUNT_LEVEL,
          CONTACT_LEVEL,
          PIPELINE_LEVEL,
        ].includes(level)
      ) {
        loading = { ...state.loading, [level]: false };
        errors = { ...state.fieldList, [level]: error };
      } else if (level) {
        loading = {
          ...state.loading,
          customObject: {
            ...state.loading.customObject,
            [level]: false,
          },
        };

        errors = {
          ...state.errors,
          customObject: {
            ...state.errors.customObject,
            [level]: error,
          },
        };
      }
      return {
        ...state,
        errors,
        loading,
      };
    }
    default:
      return state;
  }
};

export default fieldMappingReducer;
